export default "__VITE_ASSET__BriGRyK9__"